import { createSelector } from 'reselect'
import {
  DIALOG_TYPE
} from './constants'
const activeStateSelector = state => state.admin.client.active
const typeStateSelector = state => state.admin.client.type

const activeDialogSelector = createSelector(
  activeStateSelector,
  typeStateSelector,
  (active, type) => active === true && type === DIALOG_TYPE.CREATE
)

const activeSiteDialogSelector = createSelector(
  activeStateSelector,
  typeStateSelector,
  (active, type) => active === true && type === DIALOG_TYPE.UPDATE
)

export {
  activeDialogSelector,
  activeSiteDialogSelector,
}
